import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import { LimitOffsetPagination } from './Pagination'
import usePaginationMethodth from './utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitPagination',
  props: {
  pagination: {},
  extra: {
    type: Number,
    default: 2,
  },
  needAddBtns: {
    type: Boolean,
  },
},
  emits: ['input', 'changeLimit'],
  setup(__props, { expose: __expose, emit }) {
  __expose();

const props = __props;





const {
  range,
  gaps,
  fills,
  recalcRange,
  one,
  pageSizes,
} = usePaginationMethodth()

const pagelimit = ref(props?.pagination?.limit || 10)
const page = ref({})

const pageObj = computed(() => {
  const to = page.value.limit + page.value.offset
  const from = page.value.offset + one

  return { to, from }
})

watch(() => props.pagination, () => {
  page.value = new LimitOffsetPagination(props.pagination)
}, { deep: true, immediate: true, })

watch(() => page.value, () => {
  recalcRange(page.value, props.extra)
}, { immediate: true, })

const changeLimit = () => {
  emit('changeLimit', { limit: pagelimit.value })
}

const select = number => {
  emit('input', page.value.getParameters(number))
}

const next = () => {
  emit('input', page.value.next())
}

const previous = () => {
  emit('input', page.value.previous())
}

const __returned__ = { emit, props, range, gaps, fills, recalcRange, one, pageSizes, pagelimit, page, pageObj, changeLimit, select, next, previous, ref, computed, watch, get LimitOffsetPagination() { return LimitOffsetPagination }, get usePaginationMethodth() { return usePaginationMethodth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})